// src/api/authApi.ts
import { axiosInstance } from './axiosInstance';
import type { User } from '../types';

export interface AuthResponse {
  user: User;
  accessToken: string;
  refreshToken?: string; // Added refresh token as optional for now, adjust based on backend
}

export interface RefreshTokenResponse {
  accessToken: string;
}

/** 🔄 Refresh Token API */
export const refreshTokenApi = async (refreshToken: string): Promise<RefreshTokenResponse> => {
  const response = await axiosInstance.post('/auth/refresh-token', { refreshToken });
  return response.data;
};

/** 🔐 Login API */
export const loginApi = async (email: string, password: string): Promise<AuthResponse> => {
  const response = await axiosInstance.post('/auth/login', { email, password });
  return response.data;
};

/** 🧾 Register API */
export const registerApi = async (
  email: string,
  password: string,
  username: string,
  organizationAction: 'create' | 'join',
  organizationName?: string,
  organizationSlug?: string,
  inviteCode?: string,
): Promise<AuthResponse> => {
  const response = await axiosInstance.post('/auth/register', {
    email,
    password,
    username,
    organizationAction,
    organizationName,
    organizationSlug,
    inviteCode,
  });
  return response.data;
};
